<template>
  <div>
    <header-elem />
    <navigation-elem />
    <banners-elem v-if="pageloaded" />
    <div v-show="banner_loaded">
      <index-content v-if="isHomePage" />
      <generic-elem v-else />
      <testimonials-elem v-if="!isContactPage" />
      <contact-form />
      <footer-elem />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import api from "@/services/api"

import ContactForm from "@/components/ContactForm.vue"
import HeaderElem from "@/components/Header.vue"
import BannersElem from "@/components/Banners.vue"
import IndexContent from "@/components/IndexContent.vue"
import NavigationElem from "@/components/Navigation.vue"
import FooterElem from "@/components/Footer.vue"
import TestimonialsElem from "@/components/Testimonials.vue"
import GenericElem from "@/components/Generic.vue"

export default {
  name: "page",
  components: {
    ContactForm,
    HeaderElem,
    IndexContent,
    BannersElem,
    NavigationElem,
    FooterElem,
    TestimonialsElem,
    GenericElem
  },
  data() {
    return { pageloaded: false }
  },
  computed: {
    ...mapState(["page", "banner_loaded"]),
    ...mapGetters(["isHomePage", "isContactPage"])
  },
  metaInfo() {
    return {
      title: this.page.title,
      meta: [{ name: "description", content: this.page.meta_desc }, { name: "keywords", content: this.page.meta_keywords }]
    }
  },
  created: function() {
    var route = this.$route
    var url = route.params.url
    var promises = []
    var store = this.$store
    var state = this.$store.state

    if (!url) store.commit("setPage", {})

    if (route.name == "404") this.page = { main_text: "Sorry, this page cannot be found!" }

    if (route.name == "page-by-url") promises.push(api.getPageByURL(url))
    if (route.name == "root") promises.push(api.getHomePage())

    Promise.all(promises).then(vals => {
      this.pageloaded = true
      var returnedpage = vals[0]
      store.commit("setPage", returnedpage)

      if (!returnedpage || !returnedpage.ItemID) store.commit("setPage", { main_text: "Sorry, this page cannot be found!" })

      //if (!this.isHomePage && (!this.page.banners || !this.page.banners.length)) api.getPageByItemID(state.homeID, "banners").then(home => this.$set(this.page, "banners", home.banners))
      api.getPages("", "page.sub=@" + returnedpage.ParentID).then(siblings => this.$set(state.page, "siblings", siblings.filter(p => p.ItemID != returnedpage.ItemID)))
    })

    store.dispatch("getSettings")
    store.dispatch("getMainPages")
    store.dispatch("getReviews")
    store.dispatch("getBrochures")
    store.dispatch("getReviewsPage")
    store.dispatch("getPricesPage")
  }
}
</script>
